import { Component, type ReactNode } from 'react';
import { StatePanel } from './StatePanel';

const chunkReloadKey = 'korsa-chunk-reload-at';

export class AppErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidMount() {
    window.addEventListener('vite:preloadError', this.handlePreloadError);
  }

  componentWillUnmount() {
    window.removeEventListener('vite:preloadError', this.handlePreloadError);
  }

  private handlePreloadError = (event: Event) => {
    event.preventDefault();
    this.setState({ hasError: true });

    try {
      const now = Date.now();
      const lastReload = Number(window.sessionStorage.getItem(chunkReloadKey));
      if (now - lastReload < 60_000) return;
      window.sessionStorage.setItem(chunkReloadKey, String(now));
    } catch {
      return;
    }

    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="page-container">
        <StatePanel
          kind="error"
          title="Не удалось загрузить приложение"
          description="Обновите страницу. Если ошибка повторяется, попробуйте позже."
          actionLabel="Обновить страницу"
          onAction={() => window.location.reload()}
        />
      </main>
    );
  }
}
